
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tblInvAdjustment/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tblInvAdjustment/delete',
        method: 'post',
        data
    })
}
// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tblInvAdjustment/findPage',
        method: 'post',
      data
    })
}

// 完成库存调整
export const confirmAdjust = (data) => {
  return axios({
    url: '/tblInvAdjustment/confirmInvAdjustment',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tblInvAdjustment.js